module.exports = __webpack_public_path__ + "static/media/spu_menu_account.eb075c71.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/svg/spu_menu_account.svg
// module id = 222
// module chunks = 0